import Services from './services';

const tokenModel = {
    getToken: () => {
        return Services.postApiWithBasicAuth(
            Services.oauthBasePath() + '/' + process.env.REACT_APP_API_VERSION + '/oauth/token',
            'grant_type=client_credentials'
        );
    }
};

export default tokenModel;
